<template>
  <v-app>
    <div class="top-nav">
      <topnav />
    </div>
    <v-content  class="grey lighten-3">
      <!-- page content -->
      <router-view></router-view>
        <!-- /page content -->

    </v-content>
  </v-app>
</template>

<script>
import Topnav from '@/components/Topnav.vue'

export default {
  name: 'dashboard',
  components: {
    Topnav
  },
  data () {
    return {
      message: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?ea8b9ee4